import { useContext } from 'react';
import { MixpanelContext } from 'v3/contexts/MixpanelContext';

export const useMixpanel = () => {
  const mp = useContext(MixpanelContext);
  return mp;
};
